export default __webpack_public_path__ + "static/media/Champion_ashe_HP.6cbcde46.png";